import * as Yup from 'yup';
import { VehicleStatusCode } from '../../api/types/VehicleStatusCode';
import { VehicleTripFiltersData } from './modalVehicleTripFilters';
import { APP_CONFIG } from '../../constants/constants';

export const formInitialValues = {
  all_events: false,
  status_codes: [] as VehicleStatusCode[],
  idling: false,
  speeding: false,
  traffic: false,
  weather: false,
};

export const formValidationSchema = Yup.object().shape({});

export const dateInitialValues: VehicleTripFiltersData = {
  selected_date: "",
  date_from: "",
  date_to: "",
  time_from: "",
  time_to: "",
  timezone: APP_CONFIG.DEFAULT_TIMEZONE,
  calculatedUnixTimestampFrom: null,
  calculatedUnixTimestampTo: null,
}

export const dateValidationSchema = Yup.object().shape({
});